import { lazy } from "react";
import { Route, Routes } from "react-router";
import { Footer } from "./organisms/Footer/Footer";
import { Header } from "./organisms/Header/Header";
import { ScrollToTop } from "./utility/hooks/ScrollToTop";
import { Home } from "./pages/Home";
import { Portfolio } from "./pages/Portfolio";
import { Blog } from "./pages/Blog";
import { Contacts } from "./pages/Contacts";
import { PortfolioGalary } from "./pages/PortfolioGalary";
const TestComponent = lazy(
  () => import("./organisms/TestComponent/TestComponent")
);

const App = () => {
  return (
    <>
      <div className="min-h-screen bg-black">
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/test" element={<TestComponent />} />
          <Route path="/portfolio/:portfolioId" element={<PortfolioGalary />} />
        </Routes>
        <Footer />
      </div>
    </>
  );
};

export default App;
